import { DEFAULT_SEGMENT_ID } from '@candulabs/core';
import { AnyAction } from 'redux';

import { ContentSegmentDocumentMetadata, ContentSegments } from '@candu-ai/content/types';
import { TabRoute } from 'dashboard/pages/Content/pages/Analytics/SectionTabs';
import { SegmentItem } from 'dashboard/pages/Content/pages/Analytics/components/Goal/SegmentSelectInput';

import {
  SET_CONTENT_SEGMENTS,
  SET_DOWNLOADS,
  SET_SELECTED_SEGMENTS,
  SET_TABS_ROUTES,
} from './constants';

export interface AnalyticsState {
  downloads: string[];
  contentSegments: ContentSegmentDocumentMetadata[];
  selectedSegments: SegmentItem[];
  tabsRoutes: TabRoute[];
}

export const initialState: AnalyticsState = {
  downloads: [],
  contentSegments: [],
  selectedSegments: [],
  tabsRoutes: [],
};

const groupContentSegments = (contentSegments: ContentSegments) => {
  const defaultDocument = contentSegments.defaultDocumentId
    ? [
        {
          documentId: contentSegments.defaultDocumentId,
          segmentId: DEFAULT_SEGMENT_ID,
          sortIndex: 999999,
        },
      ]
    : [];
  return [...contentSegments.segmentDocuments, ...defaultDocument];
};

export const analyticsReducer = (state: AnalyticsState = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_DOWNLOADS:
      return { ...state, downloads: action.downloads };

    case SET_CONTENT_SEGMENTS:
      return { ...state, contentSegments: groupContentSegments(action.contentSegments) };

    case SET_SELECTED_SEGMENTS:
      return { ...state, selectedSegments: action.selectedSegments };

    case SET_TABS_ROUTES:
      return { ...state, tabsRoutes: action.tabsRoutes };

    default:
      return state;
  }
};
